<template>
  <div :class="{ 'fade modal-open' : isModalOpen }" class="modal in" @click.self.stop="close">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal__header" :class="headerClasses">
          <h2>Fuel Promo Terms and Conditions</h2>
        </div>
        <div class="modal-body">
          <p>The terms and conditions of Fuel Promo Funds are subject to change by Fuel Medical in its sole discretion. Fuel Promo Funds are designed to assist eligible participants with Fuel Digital Services and Audiology Growth Services including but not limited to Website Design, Search Engine Optimization, Search Engine Marketing, Social Marketing, Reputation Management, Email Marketing, Database and New Patient Print Marketing promoting Audiology and other Audiology Growth Services approved by Fuel Medical.  Fuel Medical may also apply accrued Fuel Promo Funds against any open balances with Fuel Medical. Eligible participants agree to maintain an active business relationship with Fuel Medical and to affiliate all of their hearing aid accounts with Fuel Medical’s manufacturing partners. Fuel Medical shall determine, in its sole discretion, the eligibility of a participant and whether or not a business relationship is active. Fuel Promo Funds are accrued on a rolling 18 month basis. Any unused Fuel Promo Funds accumulated longer than 18 months will be forfeited. Failure to have an active business relationship with Fuel Medical or any action to terminate a relationship with Fuel Medical will immediately forfeit any and all accrued Fuel Promo Funds. Fuel Promo Funds will not be accrued on any hearing instruments purchased for fitting under any state or federal government reimbursement program or other third-party payer program.</p>
        </div>
        <div class="modal__footer">
          <div class="modal__send-btn" @click.self.stop="closeModal">Close</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

export default {
  name: "DigitalPromoTermsModal",
  props: {
    item: {},
    modalKey: '',
    headerClass: '',
  },
  mounted() {
    const component = this;
    this.handler = function (e) {
      if (e.code === 'Escape') {
        component.closeModal();
      }
    }
    window.addEventListener('keyup', this.handler);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handler);
  },
  computed: {
    ...mapGetters('main', ['displayedModal', 'loaders']),
    isModalOpen() {
      return this.displayedModal === 'digitalPromoTermsAndConditions';
    },
    headerClasses() {
      return 'modal__header--small';
    },
  },

  methods: {
    closeModal() {
      this.$store.dispatch('main/showModal', null);
    },
  },
};
</script>
